import { computed, Injectable, signal } from '@angular/core';
import { finalize, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SpinnerController {
  #spinnerCounter = signal<number>(0);

  isSpinning = computed<boolean>(() => !!this.#spinnerCounter());

  constructor() {
    (globalThis as any).spinnerController = this;
  }

  start() {
    this.#spinnerCounter.update(value => (value += 1));
  }

  stop() {
    this.#spinnerCounter.update(value => (value = value > 0 ? value - 1 : 0));
  }
}

export function withSpinner() {
  return <T>(source: Observable<T>): Observable<T> => {
    (globalThis as any).spinnerController.start();
    return source.pipe(finalize(() => (globalThis as any).spinnerController.stop()));
  };
}
